module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0038.jpg?v=4af37af8";